// dependancies
import React from "react";
import PropTypes from "prop-types";

// styles
import InfoBoxStyled from "./InfoBox.styled";
import ContainerBox from "../../../_common/containers/ContainerBox";
import FlexStartContainer from "../../../_common/containers/FlexStartContainer";
import SideContainer from "../../../_common/containers/SideContainer";
import PageText from "../../../_common/pageText/PageText.styled";

const InfoBox = props => {
    const { config, title } = props;
    return (
        <InfoBoxStyled>
            <ContainerBox underlay>
                <FlexStartContainer className="titeContainer">
                    <span className="icon info-large"></span>
                    <div className="pt1 title">
                        <h5>{title}</h5>
                    </div>
                </FlexStartContainer>
                {config.map(data => (
                    <FlexStartContainer className="pt1">
                        <SideContainer>
                            <PageText>{data.name}</PageText>
                        </SideContainer>
                        <SideContainer>
                            <p>{data.description}</p>
                        </SideContainer>
                    </FlexStartContainer>
                ))}
                <br />
                <p className="pack-explain">* Plate/Traffic Light/Imprint and Blank Corner Blocks x 1 = 4 stamps </p>
            </ContainerBox>
        </InfoBoxStyled>
    );
};

InfoBox.propTypes = {
    config: PropTypes.array,
    title: PropTypes.string
};

export default InfoBox;
